module.exports = __webpack_public_path__ + "img/delivery-truck.8f8d0e20.svg";